import React from 'react';
import { AppBar, Toolbar, styled } from '@mui/material';
import { Colors } from 'library';
import NavyLogo from 'assets/images/NavyLogo.svg';

export default function StakeholderNav() {
    return (
        <AppBar position="static" sx={{ backgroundColor: Colors.white, boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)' }}>
            <ThinToolbar>
                <NavyLogo height={40} width={120} alt="tandem logo" />
            </ThinToolbar>
        </AppBar>
    );
}

const ThinToolbar = styled(Toolbar)({
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 24,
    paddingRight: 24,
});
